import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TableModule } from 'primeng/table';
import { ImageModule } from 'primeng/image';
import { FormsModule, ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { TabViewModule } from 'primeng/tabview';
import { ListProductComponent } from '../product/list-product.component';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { AppService } from '../../../../core/service/app.service';
import { JsonRequest } from '../../../../model/jsonRequest.model';
import { properties } from '../../../../../environments/properties';
import { StoreModel } from '../../../../model/store.model';
import { StoreStatusModel } from '../../../../model/store-status.model';

@Component({
  selector: 'app-detail-store',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    ToggleButtonModule,
    TableModule,
    ImageModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    ToastModule,
    TabViewModule,
    ListProductComponent,
    RouterLink,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './detail-store.component.html',
  styleUrl: './detail-store.component.css',
})
export class DetailStoreComponent implements OnInit {
  idStore: number = 0;
  storeInfo!: StoreModel;
  ltsStoreStatus: StoreStatusModel[] = [];
  selectedStatus: StoreStatusModel | undefined;
  loading: boolean = false;
  pendingFeatured: boolean = false;

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
    private readonly route: ActivatedRoute,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.idStore = params['idstore'];
      this.getStore();
    });
    this.getListStoreStatus();
  }

  getStore(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        sto_id: this.idStore,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.loading = true;
    this.apiService.consumirWSPost(
      properties.serviceGetStore,
      body,
      (data) => {
        this.storeInfo = data.data;
        this.pendingFeatured = this.storeInfo.sto_is_featured;
        this.resolveSelectedStatus();
        this.loading = false;
      },
    );
  }

  getListStoreStatus(): void {
    const body: JsonRequest = {
      data: '',
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSGet(
      properties.serviceGetAllStoreStatus,
      body,
      (data) => {
        this.ltsStoreStatus = data.data;
        this.resolveSelectedStatus();
      },
    );
  }

  private resolveSelectedStatus(): void {
    if (!this.storeInfo || !this.ltsStoreStatus.length) {
      return;
    }
    this.selectedStatus = this.ltsStoreStatus.find(
      (s) => s.sst_id === this.storeInfo.sto_store_status_id,
    );
  }

  changeStatus(event: Event): void {
    
    if (!this.selectedStatus) {
      return;
    }

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `¿Deseas cambiar el estado a ${this.selectedStatus.sst_name}?`,
      header: 'Cambiar Estado',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',

      accept: () => {
        const body: JsonRequest = {
          data: JSON.stringify({
            sto_id: this.storeInfo.sto_id,
            sto_store_status_id: this.selectedStatus?.sst_id,
          }),
          company: this.util.returnEmpresa(),
          fecha: new Date(),
        };

        this.loading = true;
        this.apiService.consumirWSPost(
          properties.serviceChangeStatusStore,
          body,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.util.mostrarToast(
                'Estado Cambiado',
                'El estado ha sido actualizado',
                1,
              );
              this.getStore();
            } else {
              this.util.mostrarToast(
                'Error',
                'Error al cambiar el estado',
                3,
              );
              this.loading = false;
            }
          },
        );
      },
      reject: () => {
        this.resolveSelectedStatus();
      },
    });
  }

  changeFeatured(event: Event): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `¿Deseas ${this.pendingFeatured ? 'marcar' : 'desmarcar'} el negocio como destacado?`,
      header: 'Cambiar Destacado',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',

      accept: () => {
        const body: JsonRequest = {
          data: JSON.stringify({
            sto_id: this.storeInfo.sto_id,
            sto_is_featured: this.pendingFeatured,
          }),
          company: this.util.returnEmpresa(),
          fecha: new Date(),
        };

        this.loading = true;
        this.apiService.consumirWSPost(
          properties.serviceChangeFeaturedStore,
          body,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.util.mostrarToast(
                'Destacado Actualizado',
                'El negocio ha sido actualizado',
                1,
              );
              this.getStore();
            } else {
              this.util.mostrarToast(
                'Error',
                'Error al actualizar el destacado',
                3,
              );
              this.loading = false;
            }
          },
        );
      },
      reject: () => {
        this.pendingFeatured = this.storeInfo.sto_is_featured;
      },
    });
  }

  getDayName(dayOfWeek: number): string {
    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    return days[dayOfWeek];
  }
}
